import type { FC, ReactNode } from 'react';

import { Link } from '@remix-run/react';
import cn from 'classnames';

import { TOP_BAR_ICON_CLASSES } from './topBarIconClasses';

interface TopBarIconLinkProps {
  to: string;
  label: string;
  icon: ReactNode;
  badgeCount?: number | null;
  isActive?: boolean;
}

export const TopBarIconLink: FC<TopBarIconLinkProps> = ({ to, label, icon, badgeCount, isActive = false }) => {
  return (
    <Link
      to={to}
      className={cn('relative', TOP_BAR_ICON_CLASSES, {
        'text-community-text-on-bg': isActive,
        'text-community-text-on-bg/80': !isActive,
      })}
      aria-current={isActive ? 'page' : undefined}
    >
      {icon}
      <span className="sr-only">{label}</span>
      {typeof badgeCount === 'number' && badgeCount > 0 ? (
        <span className="absolute left-[22px] top-0.5 flex md:left-5 md:top-0 h-4 min-w-4 items-center justify-center rounded-full bg-community-accent px-1 text-[10px] font-semibold leading-none text-community-text-on-primary">
          {badgeCount > 99 ? '99+' : badgeCount}
        </span>
      ) : null}
    </Link>
  );
};
